import * as React from "react";
import * as Ladda from 'ladda';
import 'ladda/dist/ladda-themeless.min.css'
import {ControlBase, ControlBaseProps, ControlBaseState, PropertyChanging} from "./base/ControlBase";
import {IconProp, library} from "@fortawesome/fontawesome-svg-core";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faSave} from "@fortawesome/free-solid-svg-icons/faSave";
import {CSSProperties} from "react";
library.add(faSave);

export class SpinnerButton extends ControlBase<SubmitButtonProps, SubmitButtonState> {
    private button:any;
    private laddaInstance:any;
    static defaultProps: Partial<SubmitButtonProps> = {
        IsBusy:false,
        Icon:"save",
        AddLabelMargin:false,
        className:'rnbtn-success',
        disabled:false,
        SpinnerColor:null
    };

    constructor(props: SubmitButtonProps, context?: any) {
        super(props, context);
    }

    public render() {
        return (
            <div  style={{display:'inline-block',...this.props.style}}>
                {this.props.AddLabelMargin&&<label style={{marginBottom:5,display:'block'}}>&nbsp;</label>}
                <button data-spinner-color={this.props.SpinnerColor} disabled={this.props.disabled}  style={{display:'inline-block'}} onClick={()=>this.props.OnClick()} ref={(node:any)=>this.button=node} data-style="expand-right" className={"rnbtn save ladda-button "+this.props.className}>
                    <span>
                        {this.props.Icon&&
                        <React.Fragment>
                            {
                                typeof this.props.Icon=='string'?<FontAwesomeIcon className="icon" icon={this.props.Icon}/>:this.props.Icon
                            }
                            <span> </span>
                        </React.Fragment>}
                         {this.props.children}
                        </span>
                </button>
            </div>
        )
    }


    componentDidMount(): void {
        this.laddaInstance = Ladda.create(this.button);
        super.componentDidMount();
    }

    @PropertyChanging
    IsBusyChanging(newValue,allProps:SubmitButtonProps){
        if(newValue)
            this.laddaInstance.start();
        else
            this.laddaInstance.stop();
    }
}


//#region ----------------------------------------------------"State and props"------------------------------------------------------------------------------------
interface SubmitButtonProps  extends ControlBaseProps{
    IsBusy:any;
    OnClick:()=>void;
    style?:CSSProperties;
    Icon?:IconProp;
    AddLabelMargin?:boolean;
    className?:string;
    disabled?:boolean;
    SpinnerColor:string;
}

interface SubmitButtonState extends ControlBaseState{

}

//#endregion "My Region"